import type { JSX } from 'react';
import { useTranslation } from 'react-i18next';
import { formatDate } from '@artosera/shared';
import { useHistoriqueOeuvre } from '../../../api/oeuvres.js';
import styles from './Tabs.module.css';

export interface HistoriqueTabProps {
  galerieSlug: string;
  oeuvreId: string;
}

/** Historique (3.3, écran 2) : `GET /oeuvres/:id/historique`, raison de correction comprise. */
export function HistoriqueTab({ galerieSlug, oeuvreId }: HistoriqueTabProps): JSX.Element {
  const { t, i18n } = useTranslation(['regie', 'commun']);
  const langue = i18n.language === 'en' ? 'en' : 'fr';
  const historique = useHistoriqueOeuvre(galerieSlug, oeuvreId);

  if (historique.isLoading) return <p className={styles.vide}>{t('commun:chargement')}</p>;
  if (!historique.data || historique.data.length === 0) {
    return <p className={styles.vide}>{t('regie:oeuvres.historiqueTab.aucun')}</p>;
  }

  return (
    <table className={styles.tableau}>
      <thead>
        <tr>
          <th scope="col">{t('regie:oeuvres.historiqueTab.colonneDate')}</th>
          <th scope="col">{t('regie:oeuvres.historiqueTab.colonneAction')}</th>
          <th scope="col">{t('regie:oeuvres.historiqueTab.colonneAuteur')}</th>
        </tr>
      </thead>
      <tbody>
        {historique.data.map((entree) => (
          <tr key={entree.id}>
            <td>{formatDate(new Date(entree.date), langue, 'court')}</td>
            <td>{entree.resume}</td>
            <td>{entree.acteurEmail}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
